import { render, staticRenderFns } from "./pay_link_class.vue?vue&type=template&id=b57d1c28"
import script from "./pay_link_class.vue?vue&type=script&lang=js"
export * from "./pay_link_class.vue?vue&type=script&lang=js"
import style0 from "./pay_link_class.vue?vue&type=style&index=0&id=b57d1c28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports